import axios from 'axios';
import { IOrder } from '@/shared/model/order.model';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { Shop } from '@/shared/model/shop.model';
import { buildURLQueryOpts } from '@/shared/query/query';

const baseApiUrl = 'api/v1/orders';

export default class ReviewOrdersService {
  public retrieve(paginationQuery?: any, searchQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}&${buildURLQueryOpts(searchQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IOrder): Promise<IOrder> {
    return new Promise<IOrder>((resolve, reject) => {
      // TODO: Temporary add this shopName to pass submittion
      const tempEntity = {
        ...entity,
        shopName: entity.shop.url,
      };
      axios
        .put(`${baseApiUrl}/${entity.id}`, tempEntity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
